import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ChromeIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 11.5724C7.3 11.5724 6.64829 11.3793 6.06896 10.9931C5.48965 10.6069 5.05516 10.1241 4.76551 9.5207L1.86896 4.5C1.26551 5.5862 1 6.76896 1 8C1 9.76206 1.5793 11.2828 2.7138 12.5862C3.84829 13.8897 5.27241 14.6621 6.96209 14.9276L8.98968 11.4034C8.79655 11.4759 8.43449 11.5724 8 11.5724Z"
		></path>
		<path
			fill="currentColor"
			d="M5.80345 5.10345C6.45516 4.59655 7.1793 4.3793 8 4.3793H14.0103C13.3828 3.31725 12.5379 2.54481 11.4759 1.94136C10.4138 1.3138 9.25516 1 8 1C6.9138 1 5.87586 1.24139 4.93449 1.7C3.99313 2.15861 3.1 2.83449 2.47241 3.70345L4.5 7.03449C4.6931 6.26206 5.15171 5.61035 5.80345 5.10345Z"
		></path>
		<path
			fill="currentColor"
			d="M14.469 5.36896H10.4138C11.1138 6.06896 11.5966 6.9862 11.5966 8C11.5966 8.74829 11.3793 9.42414 10.969 10.0517L8.07241 15C9.9793 14.9759 11.6207 14.3 12.9724 12.9241C14.3241 11.5483 15 9.9069 15 8C15 7.1069 14.8552 6.16551 14.469 5.36896Z"
		></path>
		<path
			fill="currentColor"
			d="M8 5.34484C9.44829 5.34484 10.6552 6.55174 10.6552 8C10.6552 9.44826 9.44829 10.6552 8 10.6552C6.55171 10.6552 5.34484 9.44829 5.34484 8C5.34484 6.55171 6.55171 5.34484 8 5.34484Z"
		></path>
	</svg>
))
